export function Disclaimer() {
    return (
        <section
            className="border-b border-slate-200 bg-slate-50"
            data-testid="disclaimer-section"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 py-14 md:py-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
                    <div className="lg:col-span-4">
                        <p className="reveal text-xs tracking-[0.18em] uppercase text-slate-500 mb-3">
                            04 — Limites
                        </p>
                        <h2
                            className="reveal font-display text-2xl sm:text-3xl lg:text-[2.25rem] tracking-tight text-[#0B132B] font-medium leading-[1.1]"
                            data-testid="disclaimer-title"
                        >
                            Ce que je ne fais pas
                        </h2>
                    </div>
                    <div className="lg:col-span-7 lg:col-start-6">
                        <p
                            className="reveal text-base lg:text-lg text-slate-700 leading-relaxed"
                            data-testid="disclaimer-body"
                        >
                            Je ne remplace pas les professionnels réglementés
                            lorsque leur intervention est nécessaire. Je ne
                            promets pas de résoudre automatiquement toutes
                            les situations. J'aide à comprendre ce qui doit
                            être vérifié, corrigé, encadré ou transmis à un
                            professionnel compétent.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
